<template>
  <section class="page-content--bgf7">
    <section class="statistic statistic2">
      <div class="container">
        <v-card
          class="m-b-40"
          :loading="loading"
        >
          <v-row class="p-t-5">
            <v-col md="10">
              <h1 class="title-5 m-l-15">
                <v-btn
                  text
                  icon
                  class="m-0"
                  @click="back()"
                >
                  <i class="zmdi zmdi-long-arrow-left" />
                </v-btn>
                <v-chip
                  v-if="asset.type === 'ad'"
                  color="orange lighten-5"
                >
                  AD
                </v-chip>
                {{ asset.name }}
              </h1>
            </v-col>
            <v-col
              md="2"
              class="text-right"
            >
              <v-btn
                depressed
                :disabled="loading"
                color="primary"
                class="m-r-15"
                @click="goToEditAsset()"
              >
                <v-icon left>
                  zmdi zmdi-edit
                </v-icon> Edit
              </v-btn>
            </v-col>
          </v-row>
          <div class="row">
            <div class="col-md-12 p-t-0">
              <div
                v-if="loading"
                class="el-loading-mask"
              >
                <div class="el-loading-spinner">
                  <svg
                    viewBox="25 25 50 50"
                    class="circular"
                  >
                    <circle
                      cx="50"
                      cy="50"
                      r="20"
                      fill="none"
                      class="path"
                    />
                  </svg>
                </div>
              </div>
              <v-tabs>
                <v-tab @click="showInfo=true">
                  Info
                </v-tab>
                <v-tab
                  disabled
                  @click="showRules()"
                >
                  EPG Programs (0)
                </v-tab>
              </v-tabs>
              <table class="top-info">
                <tr>
                  <td class="p-l-30">
                    <i
                      v-if="asset.state === 'pending'"
                      class="fa fa-clock blue-grey--text"
                    />
                    <i
                      v-if="asset.state === 'transcoding'"
                      class="fa fa-circle-notch fa-spin job-status--finished"
                    />
                    <i
                      v-if="asset.state === 'ready'"
                      class="fa fa-check-circle job-status--finished"
                    />
                    <i
                      v-if="asset.state === 'error' || asset.state === 'issued'"
                      class="fa fa-exclamation-circle job-status--failed"
                    />
                    <span class="p-l-10">{{ asset.state }}</span>
                  </td>
                  <td>
                    <div class="info-title">
                      <i class="zmdi zmdi-calendar p-r-10" /> Created
                    </div>
                    <div>
                      {{ moment.utc(asset.createTime).format('D MMM YY') }}
                    </div>
                  </td>
                  <td>
                    <div class="info-title">
                      <i class="zmdi zmdi-calendar p-r-10" /> Updated
                    </div>
                    <div>
                      {{ moment.utc(asset.updateTime).format('D MMM YY') }}
                    </div>
                  </td>
                  <td>
                    <div class="info-title">
                      <i class="zmdi zmdi-file-text p-r-10" />
                      ID
                    </div>
                    <div>
                      {{ asset.id }}
                    </div>
                  </td>
                </tr>
              </table>
              <template
                v-if="showInfo && ['movie', 'ad'].includes(asset.type)"
              >
                <div class="row">
                  <v-row
                    style="flex-wrap: nowrap;"
                  >
                    <v-col
                      cols="4"
                      style="max-width: 420px;"
                      class="flex-grow-1 flex-shrink-0"
                    >
                      <div class="col-md-12">
                        <v-img
                          width="400"
                          contain
                          class="grey darken-4 m-l-30"
                          :src="asset.posterId ? '/api/v1/upload/' + asset.posterId : defaultPoster"
                        />
                      </div>
                      <div
                        v-if="asset.categories.length"
                        class="col-md-12 p-l-40"
                      >
                        <span class="text-overline">Categories:</span>
                        <ul>
                          <li
                            v-for="category in asset.categories"
                            :key="'category' + category.id"
                          >
                            {{ category.name }}
                          </li>
                        </ul>
                      </div>
                      <!--v-img
                        :src="asset.poster ? asset.poster : defaultPoster"
                        max-width="400"
                        max-height="400"
                        contain
                        class="grey darken-4">
                      </v-img-->
                    </v-col>
                    <v-col
                      cols="8"
                      class="m-l-20 p-r-10 flex-grow-1 flex-shrink-0"
                    >
                      <table class="table borderless">
                        <tbody>
                          <tr v-if="asset.state === 'Failed' && asset.error">
                            <td class="error--text">
                              Error
                            </td>
                            <td class="error--text">
                              {{ asset.error }}
                            </td>
                          </tr>
                          <tr>
                            <td
                              style="width: 140px;"
                              class="grey--text"
                            >
                              Title
                            </td>
                            <td class="primary--text">
                              {{ asset.name }}
                            </td>
                          </tr>
                          <tr>
                            <td class="grey--text">
                              Description
                            </td>
                            <td>
                              <span v-if="asset.description">
                                {{ asset.description }}
                              </span>
                              <span
                                v-else
                                class="grey--text"
                              >N/A</span>
                            </td>
                          </tr>
                          <tr v-if="asset.tags.length">
                            <td class="grey--text">
                              Tags
                            </td>
                            <td>
                              <v-chip
                                v-for="(tag, i) in asset.tags"
                                :key="'tag' + tag.id"
                                :class="{ 'm-l-10': i > 0 }"
                                label
                              >
                                <v-icon left>
                                  mdi-label
                                </v-icon>
                                {{ tag.name }}
                              </v-chip>
                            </td>
                          </tr>
                          <tr v-if="asset.pubTime">
                            <td class="grey--text">
                              Pub Date
                            </td>
                            <td>
                              {{ moment(asset.pubTime).format('MMM D, YYYY HH:mm') }}
                            </td>
                          </tr>
                          <tr v-if="['movie', 'episode', 'ad'].includes(asset.type)">
                            <td class="grey--text">
                              Running time
                            </td>
                            <td>
                              <span v-if="asset.duration">
                                {{ moment.utc(asset.duration * 1000).format('HH:mm:ss') }}
                              </span>
                              <span
                                v-else
                                class="grey--text"
                              >N/A</span>
                            </td>
                          </tr>
                          <tr v-if="['movie', 'episode', 'ad'].includes(asset.type)">
                            <td class="grey--text">
                              Stream URLs
                            </td>
                            <td>
                              <table class="table table-sm output-table">
                                <tbody>
                                  <tr
                                    v-for="(stream, i) in asset.streams"
                                    :key="stream.id"
                                  >
                                    <th
                                      v-if="asset.streams.length > 1"
                                      scope="row"
                                    >
                                      {{ i+1 }}
                                    </th>
                                    <td>
                                      <a
                                        v-if="stream.state === 'ready'"
                                        href="#"
                                        @click.prevent="openPlayer(stream.streamURL)"
                                      >
                                        <i class="fas fa-play p-r-5" />
                                        {{ stream.category }}
                                      </a>
                                      <span v-else>
                                        <i
                                          v-if="stream.state === 'pending'"
                                          class="fa fa-clock blue-grey--text"
                                        />
                                        <i
                                          v-if="stream.state === 'transcoding'"
                                          class="fa fa-circle-notch fa-spin job-status--finished"
                                        />
                                        <i
                                          v-if="stream.state === 'error'"
                                          class="fa fa-exclamation-circle job-status--failed"
                                        />
                                        <span class="p-l-10">{{ stream.state }}</span>
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <span
                                v-if="!asset.streams.length"
                                class="grey--text"
                              >N/A</span>
                            </td>
                          </tr>
                          <tr v-if="['movie', 'series'].includes(asset.type)">
                            <td class="grey--text">
                              Year
                            </td>
                            <td>
                              <span v-if="asset.year">{{ asset.year }}</span>
                              <span
                                v-else
                                class="grey--text"
                              >N/A</span>
                            </td>
                          </tr>
                          <tr v-if="asset.mediaSource.name">
                            <td class="grey--text">
                              Source
                            </td>
                            <td>
                              <span class="block-email">
                                {{ asset.mediaSource.name }}
                                <span v-if="asset.mediaSource.parser">
                                  ({{ asset.mediaSource.parser }})
                                </span>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </v-col>
                  </v-row>
                </div>
                <v-row
                  v-if="asset.vodType === 'package1'"
                  no-gutters
                >
                  <v-col md="12">
                    <v-row
                      v-if="asset.assets.length === 0"
                      align="center"
                      class="spacer"
                      no-gutters
                    >
                      <v-col
                        cols="12"
                        md="12"
                        class="text-center pa-4"
                        style="border: 1px solid #0277BD;"
                      >
                        No items
                      </v-col>
                    </v-row>
                    <v-expansion-panels popout>
                      <v-expansion-panel
                        v-for="(a, i) in asset.assets"
                        :key="a.id"
                        hide-actions
                      >
                        <v-expansion-panel-header>
                          <v-row
                            align="center"
                            class="spacer"
                            no-gutters
                          >
                            <v-col
                              cols="4"
                              sm="2"
                              md="1"
                            >
                              <img
                                height="30"
                                width="30"
                                :src="a.poster ? a.poster + '?img.contain=30x30' : defaultPoster"
                                alt="Poster"
                              >
                            </v-col>
                            <v-col
                              class="hidden-xs-only"
                              sm="5"
                              md="7"
                            >
                              {{ a.name }}
                              <span
                                v-if="a.year"
                                class="grey--text"
                              >&nbsp;({{ a.year }})</span>
                            </v-col>
                            <v-col
                              cols="4"
                              sm="2"
                              md="2"
                            >
                              {{ moment.utc(a.duration * 1000).format('HH:mm:ss') }}
                            </v-col>
                            <v-col
                              class="text-center"
                              cols="4"
                              sm="2"
                              md="2"
                            >
                              <v-chip
                                color="blue lighten-4"
                              >
                                {{ i+1 }}
                              </v-chip>
                            </v-col>
                          </v-row>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-divider />
                          <v-card-text>
                            <div class="row">
                              <div class="col-md-9">
                                {{ a.shortDescription || 'no description' }}<br>
                                <a
                                  v-if="a.streamURL"
                                  href="#"
                                  @click.prevent="openPlayer(a.streamURL)"
                                >
                                  <i class="fas fa-play p-r-5" />
                                  Play
                                </a>
                              </div>
                              <div class="col-md-3">
                                <a :href="'/assets/' + a.id">
                                  <v-icon color="primary">assignment</v-icon>
                                </a>
                              </div>
                            </div>
                          </v-card-text>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                </v-row>
              </template>
              <template v-if="showInfo && asset.vodType === 'package'">
                <v-row
                  style="flex-wrap: nowrap;"
                >
                  <v-col
                    cols="8"
                    class="m-l-20 p-r-10 flex-grow-1 flex-shrink-0"
                  >
                    <table class="table package-table">
                      <tr>
                        <td
                          class="text-right text-subtitle-2"
                          style="width: 250px;"
                        >
                          Title
                        </td>
                        <td>
                          {{ asset.name }}
                        </td>
                      </tr>
                      <tr>
                        <td class="text-right text-subtitle-2">
                          Description
                        </td>
                        <td>
                          {{ asset.shortDescription || asset.longDescription || 'N/A' }}
                        </td>
                      </tr>
                      <tr>
                        <td class="text-right text-subtitle-2">
                          Total running time
                        </td>
                        <td>
                          <span v-if="asset.assets.length">
                            {{ moment.utc(totalDuration * 1000).format('HH:mm:ss') }}
                          </span>
                          <span v-else>00:00:00</span>
                        </td>
                      </tr>
                    </table>

                    <h2 class="text-overline p-t-10">
                      <i class="fa fa-list p-r-10" />Items ({{ asset.assets.length }}):
                    </h2>
                    <table class="table table-striped">
                      <tbody>
                        <tr
                          v-for="(a, i) in asset.assets"
                          :key="a.id"
                        >
                          <th scope="row">
                            #{{ i+1 }}
                          </th>
                          <td>
                            {{ a.name }}
                          </td>
                          <td>{{ moment.utc(a.duration * 1000).format('HH:mm:ss') }}</td>
                          <td>
                            <a
                              v-for="output in asset.outputs"
                              :key="output.id"
                              href="#"
                              @click.prevent="openPlayer(output.streamURL)"
                            >
                              <i class="fas fa-play p-r-5" />
                              Play
                            </a>
                          </td>
                        </tr>
                        <tr v-if="asset.assets.length === 0">
                          <td
                            colspan="4"
                            class="text-center pa-3"
                          >
                            No items
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </v-col>
                  <v-col
                    cols="4"
                    style="max-width: 420px;"
                    class="flex-grow-1 flex-shrink-0"
                  >
                    <div class="col-md-12">
                      <v-img
                        :src="asset.poster ? asset.poster : defaultPoster"
                        max-width="400"
                        class="grey darken-4 m-r-10"
                      />
                    </div>
                    <div
                      v-if="asset.categories.length"
                      class="col-md-12"
                    >
                      <span class="text-overline">Categories:</span>
                      <ul>
                        <li
                          v-for="category in asset.categories"
                          :key="'category' + category.id"
                        >
                          {{ category.name }}
                        </li>
                      </ul>
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template v-if="!showInfo">
                <v-data-table
                  :headers="programHeaders"
                  :items="programs"
                  item-key="id"
                  dense
                  :items-per-page="15"
                  sort-by="start"
                  class="elevation-1"
                  show-group-by
                >
                  <template v-slot:item.start="{ item }">
                    {{ moment.utc(item.start * 1000).utc().format('MMM D HH:mm:ss') }}
                  </template>
                  <template v-slot:item.end="{ item }">
                    {{ moment.utc(item.end * 1000).utc().format('MMM D HH:mm:ss') }}
                  </template>
                </v-data-table>
              </template>
            </div>
          </div>
        </v-card>
      </div>
    </section>

    <!-- Player -->
    <v-bottom-sheet
      v-model="playerDialog"
      max-width="960"
      :persistent="false"
      inset
    >
      <v-card tile>
        <iframe
          id="serviceFrameSend"
          :src="frameSrc"
          width="100%"
          height="380"
          frameborder="0"
        />
        <v-list>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="p-l-20 p-r-20">
                {{ asset.name }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-spacer />
          <v-btn
            depressed
            @click="closePlayer()"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </section>
</template>

<script>
  import moment from 'moment-timezone'
  import { processAsset, processProgram } from '@/store/converters'

  export default {
    data () {
      return {
        channel: {},
        showInfo: true,
        added: 'all',
        activeRow: -1,
        limit: 20,
        offset: 0,
        polling: null,
        asset: {
          tags: [],
          categories: [],
          source: {},
          streams: [],
        },
        frameSrc: '',
        playerDialog: false,
        programHeaders: [
          {
            text: 'Program start (UTC)',
            value: 'start',
            align: 'start',
            groupable: false,
          },
          {
            text: 'Program end',
            value: 'end',
            groupable: false,
          },
          {
            text: 'Rule',
            value: 'rule.description',
            align: 'right',
          },
        ],
        programs: [],
      }
    },
    computed: {
      loading () {
        return this.$store.getters.isDataLoaded
      },
      defaultPoster () {
        return '/images/poster2x3.jpg'
      },
      totalDuration () {
        let total = 0
        for (let i = 0; i < this.asset.assets.length; i += 1) {
          total += this.asset.assets[i].duration
        }
        return total
      },
    },
    created () {
      this.channel.id = this.$route.params.id
      const assetId = this.$route.params.asset_id
      this.getAssetById(assetId)
      this.setFrameSrc('')
    },
    beforeDestroy () {
      clearInterval(this.polling)
    },
    methods: {
      back () {
        if (!this.$router.prevRoute.name) {
          this.$router.prevRoute = {
            name: 'AssetListPage',
          }
        }
        this.$router.push(this.$router.prevRoute)
      },
      getAssetById (id) {
        const args = {
          id,
          $expand: 'tags,genres,categories,streams,pictures',
        }
        this.$store.commit('setPageLoader')
        this.$store.dispatch('getAssetById', args)
          .then((asset) => {
            this.asset = processAsset(asset)
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      getAssetPrograms () {
        this.$store.commit('setPageLoader')
        const args = {
          asset_id: this.asset.id,
          from: moment(this.asset.createdAt).unix(),
          to: moment(this.asset.createdAt).add(1, 'year').unix(),
        }
        this.$store.dispatch('getAssetPrograms', args)
          .then((programs) => {
            // eslint-disable-next-line no-console
            // console.log('programs', programs);
            this.programs = programs.map((p) => processProgram(p))
          })
          .catch((errorMsg) => {
            this.$store.commit('showSnackbar', {
              text: errorMsg,
              timeout: 6000,
              color: 'error',
            })
          })
          .finally(() => this.$store.commit('resolvePageLoader'))
      },
      setActiveRow (i) {
        this.activeRow = i
      },
      goToEditAsset () {
        this.$router.push({
          name: 'AssetEditPage',
          params: {
            asset_id: this.asset.id,
          },
        })
      },
      openPlayer (stream) {
        this.setFrameSrc(stream)
        this.playerDialog = true
      },
      setFrameSrc (url) {
        const link = url.replace(/^http:\/\//, 'https://')
        this.frameSrc = `/js/radiant/index2.html?src=${link}`
      },
      closePlayer () {
        this.playerDialog = false
        this.setFrameSrc('')
      },
      showRules () {
        this.showInfo = false
        if (this.asset.rulesCount) {
          this.getAssetPrograms()
        }
      },
    },
  }
</script>

<style>
  .checkboxes.v-input .v-label {
    margin-bottom: 0 !important;
  }
  .radios .v-label {
    margin: 0 !important;
  }
  .added .v-input__slot {
    padding-bottom: 0 !important;
    margin-bottom: 0 !important;
  }
  .package-table td {
    border: 0 !important;
  }
  .output-table th, .output-table td {
    border: 0 !important;
  }
</style>
